export enum StandardRates {
  INIT_GET_STANDARD_RATES = "INIT_GET_STANDARD_RATES",
  INIT_GET_STANDARD_RATES_SUCCESS = "INIT_GET_STANDARD_RATES_SUCCESS",
  INIT_GET_STANDARD_RATES_FAILED = "INIT_GET_STANDARD_RATES_FAILED",

  ADD_STANDARD_RATE = "ADD_STANDARD_RATE",
  ADD_STANDARD_RATE_SUCCESS = "ADD_STANDARD_RATE_SUCCESS",
  ADD_STANDARD_RATE_FAILED = "ADD_STANDARD_RATE_FAILED",

  EDIT_STANDARD_RATE = "EDIT_STANDARD_RATE",
  EDIT_STANDARD_RATE_SUCCESS = "EDIT_STANDARD_RATE_SUCCESS",
  EDIT_STANDARD_RATE_FAILED = "EDIT_STANDARD_RATE_FAILED",

  HANDLE_STANDARD_RATES_DRAWER = "HANDLE_STANDARD_RATES_DRAWER",
  DELETE_STANDARD_RATE = "DELETE_STANDARD_RATE",
}
